import { LegalDoc } from "../components/LegalDoc";

const SECTIONS = [
  {
    heading: "1. Titolare del trattamento",
    paragraphs: [
      "Il titolare del trattamento dei dati personali raccolti tramite ARCANA è Virginia, contattabile all'indirizzo email Virgispine@hotmail.it.",
      "Per qualsiasi domanda su questa informativa o sui tuoi dati puoi scrivere a quell'indirizzo in qualsiasi momento.",
    ],
  },
  {
    heading: "2. Quali dati raccogliamo",
    items: [
      "Dati dell'account: nome, indirizzo email e password (conservata esclusivamente in forma cifrata).",
      "Contenuti del servizio: le domande che poni, le carte estratte, le figure geomantiche generate, le interpretazioni ricevute e le date delle tue letture.",
      "Prenotazioni: servizio scelto, data, ora ed eventuali note che inserisci volontariamente.",
      "Recensioni: se invii volontariamente una recensione, conserviamo testo, valutazione, servizio recensito e data, associati al tuo account. La tua email non viene mai pubblicata. Ogni account può inviare una sola recensione.",
      "Dati tecnici di sicurezza: indirizzo IP e tentativi di accesso, usati solo per proteggere il servizio da abusi e conservati per periodi brevi.",
    ],
  },
  {
    heading: "3. Perché trattiamo i tuoi dati",
    items: [
      "Erogare le letture interattive e le consulenze che richiedi (esecuzione del servizio).",
      "Gestire il tuo account e la tua area personale.",
      "Moderare e pubblicare le recensioni che invii volontariamente (consenso): pubblicamente compaiono solo nome, testo, valutazione e servizio, mai la tua email.",
      "Garantire la sicurezza del servizio e prevenire abusi (legittimo interesse).",
      "Rispettare eventuali obblighi di legge.",
    ],
    paragraphs: ["Non utilizziamo i tuoi dati per finalità di marketing senza il tuo consenso esplicito."],
  },
  {
    heading: "4. Intelligenza artificiale e dati delle domande",
    paragraphs: [
      "Per generare l'interpretazione delle carte, la tua domanda e il tuo nome vengono trasmessi a un fornitore esterno di intelligenza artificiale (OpenAI) attraverso la piattaforma tecnica Emergent. Questi dati servono esclusivamente a produrre la tua lettura e non vengono utilizzati per pubblicità.",
      "Ti invitiamo a non inserire nelle domande dati sensibili (ad esempio informazioni sulla salute) o dati personali di terze persone.",
    ],
  },
  {
    heading: "5. Per quanto tempo conserviamo i dati",
    items: [
      "Account e letture: finché mantieni attivo l'account o finché non ne richiedi la cancellazione.",
      "Log di sicurezza e tentativi di accesso: per periodi tecnici brevi, comunque non oltre 15 giorni.",
    ],
  },
  {
    heading: "6. Chi riceve i tuoi dati",
    paragraphs: [
      "Oltre al titolare, i dati sono trattati dai fornitori tecnici che rendono possibile il servizio: l'infrastruttura di hosting e il database (piattaforma cloud) e il fornitore di intelligenza artificiale (OpenAI), limitatamente a quanto necessario per generare le interpretazioni.",
      "Il servizio non include analytics di profilazione né pubblicità.",
    ],
  },
  {
    heading: "7. Cookie",
    paragraphs: [
      "Il servizio utilizza esclusivamente cookie tecnici di sessione, necessari per mantenere il tuo accesso. Non vengono utilizzati cookie di profilazione o pubblicitari.",
    ],
  },
  {
    heading: "8. I tuoi diritti",
    paragraphs: [
      "In qualità di interessato puoi esercitare in qualsiasi momento i diritti previsti dal GDPR (artt. 15-22): accesso, rettifica, cancellazione, limitazione del trattamento, portabilità dei dati e opposizione. Puoi inoltre proporre reclamo al Garante per la protezione dei dati personali (www.garanteprivacy.it).",
      "Per esercitare i tuoi diritti scrivi a Virgispine@hotmail.it.",
    ],
  },
  {
    heading: "9. Cancellazione dell'account e dei dati",
    paragraphs: [
      "Puoi eliminare in autonomia ogni singola lettura o generazione geomantica dalla tua Area personale, e puoi eliminare l'intero account con tutti i dati associati (letture, interpretazioni, prenotazioni, recensioni, diario e dati di coppia) dalla sezione \"Privacy e dati\" della tua Area personale. In alternativa puoi scrivere a Virgispine@hotmail.it: la cancellazione viene completata entro 30 giorni, salvo obblighi di legge che impongano la conservazione di alcuni dati.",
      "In caso di eliminazione dell'account — richiesta da te o disposta dal titolare per abuso del servizio — tutti i contenuti (letture, interpretazioni, diario, dati di coppia, prenotazioni, recensioni) vengono cancellati. Fanno eccezione i soli dati necessari per adempiere agli obblighi fiscali e contabili di legge (art. 2220 c.c.), conservati per dieci anni e utilizzati esclusivamente per tali finalità: ove possibile in forma anonimizzata, senza riferimento al tuo nome o alla tua email; i documenti fiscali eventualmente emessi in forma nominativa (es. fatture su richiesta) sono conservati come previsto dalla legge.",
    ],
  },
  {
    heading: "10. Minori",
    paragraphs: ["Il servizio è riservato esclusivamente a persone maggiorenni (18+). Non raccogliamo consapevolmente dati di minori."],
  },
  {
    heading: "11. Sicurezza",
    paragraphs: [
      "Adottiamo misure tecniche adeguate: password conservate solo in forma cifrata, connessioni cifrate (HTTPS), accessi limitati ai dati e sistemi di protezione anti-abuso.",
    ],
  },
];

export default function Privacy() {
  return <LegalDoc title="Privacy Policy" tagline="Informativa sul trattamento dei dati" updated="5 ottobre 2026" sections={SECTIONS} testid="privacy-page" />;
}
